import { create } from "zustand";
import type { Workflow, WorkflowListItem } from "./workflow.types";

type WorkflowState = {
	list: WorkflowListItem[];
	total: number;
	page: number;
	limit: number;
	current: Workflow | null;
	setList: (payload: {
		list: WorkflowListItem[];
		total: number;
		page: number;
		limit: number;
	}) => void;
	setCurrent: (workflow: Workflow | null) => void;
	clear: () => void;
};

export const useWorkflowStore = create<WorkflowState>((set) => ({
	list: [],
	total: 0,
	page: 1,
	limit: 20,
	current: null,
	setList: ({ list, total, page, limit }) => set({ list, total, page, limit }),
	setCurrent: (workflow) => set({ current: workflow }),
	clear: () => set({ list: [], total: 0, page: 1, limit: 20, current: null }),
}));
